module.exports = __webpack_public_path__ + "img/holiday-icon.2cbe44e2.png";